import React, { Component, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { getTodaysMethodRegistered } from "../../../actions/report";
import {
    Row,
    Col,
    Skeleton,
    Card,
} from "antd";

const TodaysMethodRegistered = ({
    getTodaysMethodRegistered,
    Auth,
    location,
    loading,
    setloading,
    reload,
    setreload,
}) => {
    const [methodList, setMethodList] = useState([]);

    useEffect(() => {
        getTodaysMethodRegistered(location.current).then((result) => {
            setMethodList(result || []);
            setloading(false);
        });
    }, [reload, location.current]);

    const Rendercontent = () => {
        if (loading) {
            return (
                <>
                    <Skeleton active />
                </>
            );
        } else {
            return (
                <>
                    <Row>
                        <Col
                            span={24}
                            style={{ padding: "0.5rem", border: "1px solid whitesmoke" }}
                        >
                            <Row>
                                <Col span={24}>
                                    <Card
                                        title="Today's Payment Summary"
                                        className="summary_card transactions stock"
                                        bordered={true}
                                    >
                                        {methodList.map((item, index) => (
                                            <Row key={index}>
                                                <Col span={20}>
                                                    <p>{item.Payment_method || "N/A"}</p>
                                                </Col>
                                                <Col span={4} style={{ textAlign: "right" }}>
                                                    {parseFloat(item.total || 0).toFixed(2)}
                                                </Col>
                                            </Row>
                                        ))}
                                        {methodList.length === 0 && (
                                            <p style={{ textAlign: "center" }}>No records for today</p>
                                        )}
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
            );
        }
    };

    return (
        <>
            <div>{Rendercontent()}</div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        Auth: state.auth,
    };
};

export default connect(mapStateToProps, {
    getTodaysMethodRegistered,
})(TodaysMethodRegistered);
